import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

/**
 * Common styles for the CTAs regarding migration status
 */
const Styles = {
  root: backgroundColor =>
    css`
      background-color: ${backgroundColor};
      border-bottom: 1px solid ${Colors.GrayWarm3};
      padding: 20px;
    `,
};

export default Styles;
